import { render, staticRenderFns } from "./HolidayGeneratorTemplate.vue?vue&type=template&id=15b83cc0&"
import script from "./HolidayGeneratorTemplate.vue?vue&type=script&lang=ts&"
export * from "./HolidayGeneratorTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAutocomplete,VBtn,VChip})
